<div class="progress-dialog-wrapper">
  <div mat-dialog-content>
    <div class="message-container">
      <div class="message" *ngFor="let message of data.messages">{{message}}</div>
    </div>

    <div
      class="progress-container"
      fxLayout="row"
      fxLayoutAlign="start center"
      fxLayoutGap="10px"
    >
      <div class="progress-text">{{data.progress}}%</div>
      <mat-progress-bar mode="determinate" [value]="data.progress"></mat-progress-bar>
    </div>
  </div>

  <div mat-dialog-actions align="center">
    <app-action-button
      id="cancel-btn"
      cdkFocusInitial
      [title]="data.cancelText"
      (buttonClicked)="handleCancel()"
    ></app-action-button>
  </div>
</div>
